module.exports = __webpack_public_path__ + "static/media/logoscreen2ru.aa3765ea.pdf";